module.exports = __webpack_public_path__ + "static/media/gasprice.fc6790c8.png";